<template>
  <validation-provider
    tag="div"
    name="gender"
    :rules="rules"
    mode="passive"
    v-slot="{ errors }"
  >
    <form-label for="gender">
      Gender
      <span class="leading-none text-red-400" aria-hidden="true">*</span>
      <span class="sr-only">(required)</span>
    </form-label>
    <form-select
      id="gender"
      v-model="internalValue"
      @change="onInput"
      aria-required="true"
      :aria-describedby="errors[0] ? 'gender-error' : null"
      :aria-invalid="!!errors[0]"
    >
      <option value="" disabled aria-label="Choose your gender">Choose your gender</option>
      <option value="M" aria-label="Male">Male</option>
      <option value="F" aria-label="Female">Female</option>
      <option value="O" aria-label="Other">Other</option>
    </form-select>
    <form-alert-msg
      v-if="errors[0]"
      id="gender-error"
      role="alert"
      aria-live="assertive"
    >{{ errors[0] }}</form-alert-msg>
  </validation-provider>
</template>

<script>
import { FormSelect, FormLabel, FormAlertMsg } from "@/components/Form/";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", { ...required, message: "This field is required." });

export default {
  components: {
    ValidationProvider,
    FormSelect,
    FormLabel,
    FormAlertMsg,
  },
  props: ["value"],
  data() {
    return {
      internalValue: "",
      errorId: "gender-error"
    };
  },
  computed: {
    rules() {
      return "required";
    },
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
};
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>